import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Section = styled.section`
    position: relative;
    padding: 0 10px;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-image: url(${(props) => props.backgroundImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        filter: blur(5px);
        z-index: -1;
    }
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        transition: 0.5s;
        opacity: ${(props) => (props.isOpen ? '1' : '0')};
        background: rgba(0, 0, 0, 0.35);
    }
`;

export const Title = styled.h3`
    color: #4b5259;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 0;
    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

export const Text = styled.p`
    color: #4b5259;
    font-size: 18px;
    font-weight: 400;
    margin-top: 20px;
    @media (max-width: 768px) {
        font-size: 14px;
        margin-top: 15px;
    }
`;
export const SearchSelectorItems = styled.div`
    /* overflow-y: scroll; */
    height: 442px;
    ::-webkit-scrollbar {
        width: 4px;
    }
    ::-webkit-scrollbar-track {
        background-color: #fff;
    }
    ::-webkit-scrollbar-track-piece {
        background-color: #fff;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #4a4a4a;
    }
    ::-webkit-scrollbar-corner {
        background-color: #fff;
    }
    ::-webkit-resizer {
        background-color: #4a4a4a;
    }
`;

export const SearchSelectorScroll = styled.div`
    overflow-y: scroll;
    height: 100%;
    ::-webkit-scrollbar {
        width: 20px;
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px grey;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: #8e8a8a;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #5d5a5a;
    }
`;
export const SearchSelector = styled.div`
    width: 620px;
    position: absolute;
    transition: 0.5s;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    font-size: 23px;
    color: #9b9b9b;
    padding: 0 25px 0 23px;
    box-sizing: border-box;
    cursor: pointer;
    background: #fff;
    overflow-x: hidden;
    overflow-y: hidden;
    z-index: 20;
    @media (max-width: 768px) {
        width: 340px;
        left: 10px;
    }
    @media (max-width: 390px) {
        width: 90%;
        left: 5%;
        font-size: 20px;
        padding: 0 20px 0 10px;
    }
`;
export const SearchSelectorHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 72px;
`;
export const WrapperForText = styled.div`
    margin: 0 40px 0 50px;
    @media (max-width: 768px) {
        margin: 0;
    }
`;
export const Arrow = styled.div`
    border: solid #4b5259;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 6px 6px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
`;
export const SearchSelectorItem = styled(Link)`
    font-size: 22px;
    line-height: 34px;
    color: #9b9b9b;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    &:hover {
        text-decoration: none;
        color: #9b9b9b;
    }
`;
